<mc-license-url-card></mc-license-url-card>
<mc-about-footer class="mc-page-full-footer"></mc-about-footer>
